import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminLindaAiKeys = {
  index: async(props) => {
    const { default: LindaAiKeysIndex } = await import('@/vue_widgets/admin/linda_ai_keys/index.vue')
    createVueApp(LindaAiKeysIndex, { props })
  }
}
